import * as numeral from 'numeral';
import * as React from 'react';
import styled from 'styled-components';
import Context from '../../State/Context';
import { EPage, ESourceType } from '../../Types/Model';
import Button from '../Button';
import CollapsableSummary from '../CollapsableSummary';
import Markdown from '../Markdown';
import TotalFooter from '../TotalFooter';

const Disclaimer = styled.div`
    font-size: 0.8em;
`;

const FinalNote = styled.div`
`;

export default class TotalWaterUse extends React.Component {
    public render() {
        return (
            <Context.Consumer>
                {({ userState, messages, getTotal, onGotoNamedPage }) => {
                    const {
                        title,
                        description,
                        headingTotal,
                        subheadingIndustrialAndCommercialWaterUse,
                        subheadingUnlicensedWaterUse,
                        buttonPrint,
                        disclaimer,
                        finalNote,
                    } = messages.page5;

                    const {
                        garden,
                        household,
                        fireFightingFirePumpAndHoses,
                        fireFightingSprinklerSystem,
                        // weedControl,
                        horseWashdown,
                        horseFloatWashdownSmall,
                        horseFloatWashdownLarge,
                        enabledOptions,
                        stockSelections,
                        otherUnlicensedSelections,
                        cropSelections,
                        otherCropSelections,
                        activitySelections,
                        otherActivitySelections,
                    } = userState;

                    const isEnabled = (type: ESourceType) => enabledOptions.indexOf(type) > -1;

                    const unlicensedItems = [
                        ...(isEnabled(ESourceType.Household) ? [{...household, suffix: 'dwellings'}] : []),
                        ...(isEnabled(ESourceType.Garden) ? [{...garden, suffix: 'hectares irrigated'}] : []),
                        ...(isEnabled(ESourceType.FireFightingFirePumpAndHoses) ? [{...fireFightingFirePumpAndHoses, suffix: 'dwellings'}] : []),
                        ...(isEnabled(ESourceType.FireFightingSprinklerSystem) ? [{...fireFightingSprinklerSystem, suffix: 'dwellings'}] : []),
                        ...(isEnabled(ESourceType.HorseWashdown) ? [{...horseWashdown, suffix: 'washes per year'}] : []),
                        ...(isEnabled(ESourceType.HorseFloatWashdownSmall) ? [{...horseFloatWashdownSmall, suffix: 'washes per year'}] : []),
                        ...(isEnabled(ESourceType.HorseFloatWashdownLarge) ? [{...horseFloatWashdownLarge, suffix: 'washes per year'}] : []),
                        // ...(isEnabled(ESourceType.WeedControl) ? [{...weedControl, suffix: 'hectares sprayed'}] : []),
                        ...(isEnabled(ESourceType.Stock) ? stockSelections.map(item => ({...item, suffix: 'head'})) : []),
                        ...(isEnabled(ESourceType.OtherUnlicensed) ? otherUnlicensedSelections.map(item => ({...item, suffix: 'kL/annum'})) : []),
                    ]
                    .filter(item => item.total !== '0');

                    const licensedItems = [
                        ...cropSelections.map(item => ({...item, suffix: 'hectares irrigated'})),
                        ...(isEnabled(ESourceType.OtherCrop) ? otherCropSelections.map(item => ({...item, suffix: 'kL/annum'})) : []),
                    ]

                    const industrialItems = [
                        ...activitySelections.map(item => ({...item, suffix: 'units'})),
                        ...(isEnabled(ESourceType.OtherActivity) ? otherActivitySelections.map(item => ({...item, suffix: 'kL/annum'}) ): []),
                    ];

                    const goToUnlicensed = () => onGotoNamedPage(EPage.UnlicensedWaterUse);
                    const goToLicensed = () => onGotoNamedPage(EPage.LicensedWaterUse);
                    // const goToIndustrial = () => onGotoNamedPage(EPage.IndustrialAndCommercial);
                    const total = getTotal(EPage.TotalWaterUse) + ' kL';
                    const licensedAndIndustrialCombined = [
                        ...licensedItems,
                        ...industrialItems,
                    ]
                    .filter(item => item.total !== '0');

                    const combinedTotal = numeral(numeral(getTotal(EPage.IndustrialAndCommercial)).value() + numeral(getTotal(EPage.LicensedWaterUse)).value()).format('0,0.00');
                    const print = () => {
                        // @ts-ignore CSSStyleSheet now takes one argument for the media type of the stylesheet, TypeScript is out of date
                        const stylesheet: CSSStyleSheet = new CSSStyleSheet({ media: "print" });
                        stylesheet.insertRule(`:not(:has(#mlr-water-calculator), #mlr-water-calculator, #mlr-water-calculator *) { display: none; }`);
                        stylesheet.insertRule(`:has(#mlr-water-calculator) { display: contents; }`);
                        // @ts-ignore adoptedStyleSheets does exist on type document, TypeScript it out of date
                        document.adoptedStyleSheets.push(stylesheet);
                        window.print();
                        // @ts-ignore adoptedStyleSheets does exist on type document, TypeScript it out of date
                        document.adoptedStyleSheets.pop();
                        return false;
                    }
                    return (
                        <div>
                            <h2>{title}</h2>
                            <Markdown source={description}/>

                            {unlicensedItems.length > 0 && <CollapsableSummary title={subheadingUnlicensedWaterUse} total={getTotal(EPage.UnlicensedWaterUse) + ' kL'} items={unlicensedItems} onEdit={goToUnlicensed}/>}
                            {licensedAndIndustrialCombined.length > 0 && <CollapsableSummary title={subheadingIndustrialAndCommercialWaterUse} total={combinedTotal + ' kL'} items={licensedAndIndustrialCombined} onEdit={goToLicensed}/>}

                            <hr className="green"/>
                            <TotalFooter label={headingTotal} total={total} />

                            <hr className="purple" style={{ marginTop: 16, marginBottom: 0 }}/>

                            <FinalNote className="FinalNote">
                                <Markdown source={finalNote}/>
                            </FinalNote>

                            <Disclaimer className="Disclaimer">{disclaimer}</Disclaimer>

                            <div style={{ marginTop: 16 }}>
                                <Button onClick={print}>{buttonPrint}</Button>
                            </div>
                        </div>
                    );
                }}
            </Context.Consumer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Pages/TotalWaterUse.tsx